import ImagePlaceholder from "assets/icons/imagePlaceholder.svg"
import { ProductHighlightFragment } from "client/graphql/commerce-v2-api"
import {
  MultiProductTileImageWrapper,
  Tile,
  TileFeatured,
  TilePriceWrapper,
  TileTextWrapper,
  TileTitle,
} from "client/packages/commerce/components/product/MultiProductTile"
import { Price } from "client/packages/commerce/components/ui/priceComponents/Price"
import { MouseEventHandler } from "react"
import { FormattedMessage } from "react-intl"
import styled from "styled-components"

const TargetTileTextWrapper = styled(TileTextWrapper)`
  font-family: "Target", Helvetica, sans-serif;
`

export type MultiProductTileProps = {
  product: ProductHighlightFragment
  onClick?: MouseEventHandler<HTMLButtonElement>
  isFeatured?: boolean
  currencyCode: string
}

const MultiProductTile = ({
  product,
  currencyCode,
  onClick = () => {},
  isFeatured = false,
}: MultiProductTileProps) => {
  return (
    <Tile
      onClick={onClick}
      key={product.id}
      data-featured={isFeatured}
      type="button"
    >
      <MultiProductTileImageWrapper
        $src={product.preselectedVariant.featuredImage.url}
        role="img"
        aria-label={product.preselectedVariant.featuredImage.altText || ""}
      >
        {!product.preselectedVariant.featuredImage.url && (
          <ImagePlaceholder />
        )}
      </MultiProductTileImageWrapper>
      <TargetTileTextWrapper>
        {isFeatured && (
          <TileFeatured>
            <FormattedMessage
              id="multiproductTile.featured"
              defaultMessage="Featured"
            />
          </TileFeatured>
        )}
        <TileTitle $maxLines={isFeatured ? 3 : 2}>
          {product.title}
        </TileTitle>
        <TilePriceWrapper>
          <Price
            amount={product.preselectedVariant.price}
            currencyCode={currencyCode}
            showCurrencyCode={false}
          />
        </TilePriceWrapper>
      </TargetTileTextWrapper>
    </Tile>
  )
}

export default MultiProductTile
